var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edit"},[_vm._m(0),_c('span',[_vm._v("Successfully modified")]),_c('button',{on:{"click":_vm.btnClick}},[_vm._v("Log in again")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":require("@/assets/images/personal/success.png")}})])
}]

export { render, staticRenderFns }